import { FC } from 'react'
import { useIntl } from 'react-intl'
import { useAppProviderContext } from '../../core/application/contexts'
import AutocompleteDetails from '../../core/domain/models/AutocompleteDetails'
import AutocompleteSuggestion from '../../core/domain/models/AutocompleteSuggestion'
import SearchInputWrapper from '../shared/SearchInputWrapper'
import { LocationType } from '../../core/domain/models'
import { Location } from '../../core/domain/models/Location'

interface MobileSearchInputProps {
  onSelectCallback: (location: Location) => void
}

const MobileSearchInput: FC<MobileSearchInputProps> = ({ onSelectCallback }) => {
  const { dropOffProvider, multisearchProvider } = useAppProviderContext()
  const intl = useIntl()

  const onSelect = (suggestion: AutocompleteSuggestion, callback: () => void) => {
    const { api, id } = suggestion
    if (suggestion.api === 'store') {
      dropOffProvider?.fetchDropOffByStoreId(suggestion.id).then((dropOff) => {
        if (dropOff) {
          onSelectCallback({
            lng: dropOff.coordinate.longitude,
            lat: dropOff.coordinate.latitude,
            locationType: 'poi'
          })
          callback()
        }
      })
    } else {
      multisearchProvider?.detailsMulti({ api, id }).then((details: AutocompleteDetails | null) => {
        if (details) {
          const { location } = details.geometry
          let locationType: LocationType = 'poi'
          if (details.types.includes('locality')) {
            locationType = 'city'
          } else if (details.types.includes('country')) {
            locationType = 'country'
          }
          onSelectCallback({
            ...location,
            locationType
          })
        }
        callback()
      })
    }

  }

  return (
    <SearchInputWrapper
      placeholder={intl.formatMessage({ id: 'DropOffLocation.search.searchPlaceholder' })}
      onSelect={onSelect}
    />
  )
}

export default MobileSearchInput
